import { fetchData } from '@umu/umu-fetch';
import { IAdapter, ITrackParams } from '../types';

export class BesChannelsAdapter implements IAdapter {
    public name = 'besChannels';
    private config: any;
    private initialized = false;

    public async init(config?: any): Promise<void> {
        this.config = config || {};

        try {
            await this.loadScript();
            this.initCollect();

            // 如果用户有 UnionID 或 OpenID，需要将用户信息放到单独的外部数据源对象下
            if (this.config.userFlag?.UnionID || this.config.userFlag?.OpenID) {
                this.reportDes();
            }

            this.initialized = true;
        } catch (error) {
            console.log('[BesChannelsAdapter:init] ', error);
        }
    }

    public async track(params: ITrackParams, eventName: string): Promise<void> {
        if (!this.initialized) {
            return;
        }

        try {
            window.myCollect?.$customClick({
                action: 'click_other',
                props: { click_name: eventName },
                setUserFlag: {
                    ...(this.config.userFlag || {}),
                    PhoneNumber: params.phone || '',
                    Email: params.email || '',
                },
            });
        } catch (error) {
            console.log('[BesChannelsAdapter:track] ', error);
        }
    }

    private loadScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            const existingScript = document.querySelector(`script[src="${this.config.scriptUrl}"]`);
            if (existingScript) {
                if (window.Collect) {
                    resolve();
                } else {
                    (existingScript as HTMLScriptElement).addEventListener('load', () => resolve());
                    (existingScript as HTMLScriptElement).addEventListener('error', reject);
                }
                return;
            }

            const script = document.createElement('script');
            script.src = this.config.scriptUrl;
            script.type = 'text/javascript';
            script.onload = () => resolve();
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }

    private initCollect() {
        if (!window.myCollect && window.Collect) {
            window.myCollect = new window.Collect({
                org_id: this.config.orgId,
                event_props: this.config.eventProps,
                userFlag: this.config.userFlag,
            });
            window.myCollect?.init(this.config.initOptions);
        }
    }

    private reportDes() {
        fetchData(this.config.desReportAPI).catch((err: any) => {
            console.log('[BesChannelsAdapter:reportDes] ', err);
        });
    }
}
